import React from 'react';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import Dropdown from '../../../../../../components/Dropdown';
import ExpiryDisplay from '../ExpiryDisplay';

export default function RowCategory({ styles, rsStyles, categories, f, exp, errors = {} }) {
  return (
    <FormRow className={rsStyles.rowFourTight}>
      <Field label="Schedule" error={errors?.schedule}>
        <Dropdown
          options={['0', '1', '2', '3', '4', '5', '6']}
          value={f.schedule}
          onChange={f.setSchedule}
          className={styles.tallInput}
          placeholder="Select"
          alignLeft
        />
      </Field>
      <Field label="Bin Number" error={errors?.binnumber}>
        <input
          className={styles.tallInput}
          type="text"
          value={f.binNumber}
          onChange={e => f.setBinNumber(e.target.value)}
          placeholder="Enter bin number"
        />
      </Field>
      <Field label="Expiry Date" error={errors?.expirydates}>
        <ExpiryDisplay
          styles={styles}
          value={exp.expiryDisplay}
          onOpen={() => exp.setShowExpiryModal(true)}
        />
      </Field>
    </FormRow>
  );
}
